import { Button, Form, List, Modal } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import Question from "../../Classes/Question";
import { questionModalSliceDispatch, questionServiceQuestionBrandModalSliceDispatch, questionViewerSliceDispatch, standardQuestionSliceDispatch } from "../../Constants/ReduxConstants";
import StandardQuestion from "./StandardQuestion";

const StandardQuestionSelectModal = () => {
    const currentQuestions = useSelector((state: any) => state.pickAFile.questions);
    const currentServiceQuestions = useSelector((state: any) => state.pickAFile.serviceQuestions);
    const currentAddressStart = useSelector((state: any) => state.pickAFile.addressStart);
    const currentServiceQuestionBrand = useSelector((state: any) => state.pickAFile.serviceBrandQuestions);
    const currentLayout = useSelector((state: any) => state.pickAFile.layout);
    const questions = useSelector((state: any) => state.standardQuestionViewer.questions);
    const open = useSelector((state: any) => state.standardQuestionViewer.selectOpen);

    const dispatch = useDispatch();

    const onSelect = (standardQuestion: StandardQuestion) => {
        dispatch({ type: standardQuestionSliceDispatch.setSelectedQuestion, payload: standardQuestion });

        let question: Question = new Question();
        let maxIndex = currentAddressStart;
        if (currentQuestions?.length > 0) {
            maxIndex = Math.max(...currentQuestions.map((o: any) => o.questionId));
            maxIndex++;
        }

        question.questionId = maxIndex;
        question.dataKey = standardQuestion.dataField;
        question.label = standardQuestion.label;
        question.minLength = standardQuestion.minLength;
        question.type = standardQuestion.type;
        question.required = standardQuestion.required ? 1 : 0;
        question.readonly = standardQuestion.readonly;
        question.hidden = standardQuestion.hidden ? 1 : 0;
        question.sensitive = standardQuestion.sensitive;

        let layout = currentLayout.filter((s: any) => s.name.toLowerCase() == standardQuestion.category && s.tab.toLowerCase() == standardQuestion.tab)
        layout[0]?.fields.push(question.dataKey);

        dispatch({ type: standardQuestionSliceDispatch.setSelectLayout, payload: layout });

        dispatch({ type: questionViewerSliceDispatch.setEditModal, payload: true })
        dispatch({ type: questionViewerSliceDispatch.setAddModal, payload: false })
        dispatch({ type: questionModalSliceDispatch.setOpen, payload: true });
        dispatch({ type: questionModalSliceDispatch.setQuestionToAdd, payload: question });
        dispatch({
            type: questionModalSliceDispatch.setPendingServices,
            payload: currentServiceQuestions.filter((s: any) => s.questionId === question.questionId).map((s: any) => s.assistanceServiceId) ?? []
        });
        dispatch({ type: questionViewerSliceDispatch.setCurrentQuestion, payload: question });
        dispatch({ type: questionViewerSliceDispatch.setIndexOverride, payload: maxIndex });
        dispatch({
            type: questionServiceQuestionBrandModalSliceDispatch.setPendingServiceBrandQuestions,
            payload: currentServiceQuestionBrand.filter((s: any) => s.questionId === question.questionId)
        });

        dispatch({ type: standardQuestionSliceDispatch.setSelectOpen, payload: false });
    }

    const onCancel = () => {
        dispatch({ type: standardQuestionSliceDispatch.setSelectOpen, payload: false });
    }

    const select = (
        <Modal
            title="Question Details"
            footer={null}
            closable={false}
            open={open}
            destroyOnHidden={true}
        >
            <Form
                onFinishFailed={onCancel}
                preserve={false}
            >
                <Form.Item>
                    <div>
                        <List
                            dataSource={questions}
                            renderItem={(currentQuestion: StandardQuestion, index) => (
                                <div key={"question_" + index}>
                                    <List.Item key={currentQuestion.dataField}>
                                        <List.Item>
                                            <Button onClick={() => onSelect(currentQuestion)}>
                                                Select
                                            </Button>
                                            {currentQuestion.dataField}
                                        </List.Item>
                                    </List.Item>
                                </div>
                            )} />
                    </div>
                </Form.Item>
                <div style={{ display: 'flex', justifyContent: 'end', paddingTop: '1em' }}>
                    <Form.Item>
                        <Button onClick={onCancel}>
                            Cancel
                        </Button>
                    </Form.Item>
                </div>
            </Form>
        </Modal>
    )

    return select;
}

export default StandardQuestionSelectModal